export const deleteComma = (targetStr: string | number = '') => (targetStr ? Number(String(targetStr).replace(/,/g, '')) || 0 : 0);
export const deleteCommaStr = (targetStr: string | number = '') => (targetStr ? String(String(targetStr).replace(/,/g, '')) || '' : '');
